import VAvatar from './VAvatar';

VAvatar.install = function install(Vue) {
  Vue.component(VAvatar.name, VAvatar);
};

export default VAvatar;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VAvatar/index.js
// module id = RWpw
// module chunks = 0